import { defineComponent as _defineComponent } from 'vue'
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { GridComponent, DatasetComponent } from "echarts/components";
import { BarChart } from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from 'echarts/components';
import VChart, { THEME_KEY } from 'vue-echarts';
import { ref, provide, onMounted } from 'vue';
import chartsApi from '@/api/charts';


export default /*#__PURE__*/_defineComponent({
  __name: 'bar',
  setup(__props, { expose: __expose }) {

use([
    CanvasRenderer,
    BarChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    DatasetComponent,
    GridComponent,
]);

provide(THEME_KEY, 'default');
const chart = ref();
let dataArr = ref([]);
const option = ref({
    title: {
        text: '漫画类型分布',
        left: 'center',
    },
    xAxis: {
        type: 'category',
        data: ['条漫', '单页', '双页', '裁切']
    },
    yAxis: {
        type: 'value'
    },
    series: [
        {
            data: dataArr,
            type: 'bar'
        }
    ]
});

function random() {
    return Math.round(300 + Math.random() * 700) / 10;
}

function resize() {
    chart.value.resize();
}

__expose({ resize });

onMounted(async () => {
    const res = await chartsApi.browse();
    dataArr.value = res.request.map((item: any) => item.num)
})

const __returned__ = { chart, get dataArr() { return dataArr }, set dataArr(v) { dataArr = v }, option, random, resize, get VChart() { return VChart } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})